import { render, staticRenderFns } from "./ExamProject.vue?vue&type=template&id=7f3ae3f0&scoped=true"
import script from "./ExamProject.vue?vue&type=script&lang=js"
export * from "./ExamProject.vue?vue&type=script&lang=js"
import style0 from "./ExamProject.vue?vue&type=style&index=0&id=7f3ae3f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ae3f0",
  null
  
)

export default component.exports